
const ACTIONS = {
    CALL_API: 'call-api',
    SUCCESS: 'success',
    ERROR: 'error',

    SET_INITIAL_DATA: 'set-data',
    DATE_CHANGE: 'date-change',
    DATE_SET_ERRORS: 'date-set-errors',
    DATE_REMOVE_ERRORS: 'date-remove-errors',
};

const dateInputDataReducer = (state, action) => {
    //console.log("date input dispatch triggered", state, action);

    switch (action.type) {
        case ACTIONS.SET_INITIAL_DATA: {
            return {
                ...state,
                value: action.value,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }
        case ACTIONS.DATE_CHANGE: {
            //console.log("state-TEXTCHANGE");
            //console.log(state);
            
            return {
                ...state,
                value: action.value,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }
        case ACTIONS.DATE_SET_ERRORS: {
            //console.log("state");
            //console.log(state);

            return {
                ...state,
                validation:{
                    ...state.validation,
                    isInvalid: action.errors != null && action.errors.length > 0 ? true : false,
                    errors: action.errors
                }
            };
        }
        case ACTIONS.DATE_REMOVE_ERRORS: {
            return {
                ...state,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: []
                }
            };
        }
    }
}



export {ACTIONS, dateInputDataReducer};